export var MESSAGE_ACTION_CLASS_PREFIX = 'MessageAction';